<template>
  <div class="upload-container">
    <el-upload
      ref="uploadRef"
      class="upload-container"
      action
      :auto-upload="true"
      :http-request="handleUploadRequest"
      :show-file-list="false"
      :data="data"
      :disabled="disabled"
      :headers="{ Authorization: accountStore.token }"
      :before-upload="handleBeforeUpload"
      :on-progress="handleUploadProgress"
      :on-success="handleUploadSuccess"
      :on-error="handleUploadError"
    >
      <el-button
        class="textBtn"
        type="primary"
        :plain="plain"
        :size="size"
        :disabled="disabled"
      >
        {{ showName }}
        <svg-icon
          v-if="showIcon"
          class="iconShow"
          iconClass="upload1"
        ></svg-icon>
      </el-button>
    </el-upload>
  </div>
</template>

<script setup>
import { alertBox, confirmBox, errorMsg, succesMsg } from "@/utils/msgBox.ts";
import useAccountStore from "@/store/modules/account.js";
import { ElLoading } from "element-plus";
import { ref } from "vue";
import axios from "axios";

const accountStore = useAccountStore();
const uploadRef = ref(null);
const props = defineProps({
  showName: {
    required: false,
    type: String,
    default: "导入",
  },
  actionAddr: {
    required: true,
    type: String,
  },
  tips: {
    required: false,
    type: String,
    default: "",
  },
  data: {
    // 上传时附带的额外参数
    required: false,
    type: Object,
    default: {},
  },
  disabled: {
    // 是否禁用上传
    required: false,
    type: Boolean,
    default: false,
  },
  showIcon: {
    required: false,
    type: Boolean,
    default: false,
  },
  size: {
    required: false,
    type: String,
    default: "default",
  },
  plain: {
    required: false,
    type: Boolean,
    default: false,
  },
  resDataType: {
    // 返回文件类型
    required: false,
    type: String,
    default: "",
  },
});
// 文件上传地址
const action = process.env.VUE_APP_BASE_API + props.actionAddr;
let LoadingInstance;
const handleUploadRequest = (file) => {
  LoadingInstance = ElLoading.service({
    lock: true,
    text: `正在导入 ${file.file.name}，请稍后`,
    background: "rgba(0, 0, 0, 0.7)",
  });
  // console.log(file)
  let param = new FormData();
  param.append("file", file.file);
  if (Object.keys(props.data).length > 0) {
    for (let key in props.data) {
      param.append(key, props.data[key]);
    }
  }
  axios({
    url: action,
    method: "post",
    data: param,
    timeout: 0,
    headers: {
      "Content-Type": "multipart/form-data;boundary = " + new Date().getTime(),
      Authorization: accountStore.token,
    },
    responseType:
      props.actionAddr === "/nodeInfo/importNodeInfoExcel" ||
      props.resDataType === "file"
        ? "blob"
        : "",
  })
    .then((res) => {
      // if(res.data.status == -1){
      //   handleUploadError(res.data)
      // }else if(res.data.status == 1){
      // }
      handleUploadSuccess(res.data, file.file);
      // formDate.value.previewReceiptPicture = res.data.data
      // formDate.value.receiptPictureConf = JSON.stringify(canvasArr.value)
      // saveReceiptTem({...formDate.value,type:props.type})
      // console.log(res)
    })
    .catch((err) => {
      handleUploadError(err.data);
    });
};

// 文件上传前询问是否进行上传
const handleBeforeUpload = async (rawFile) => {
  return new Promise(async (resolve, reject) => {
    let sizeStr = "0 KB";
    let size = rawFile.size / 1024;
    if (size < 1024) {
      sizeStr = `${size.toFixed(3)} KB`;
    } else {
      size = size / 1024;
      sizeStr = `${size.toFixed(3)} MB`;
    }
    let tips = props.tips;
    if (props.tips.length > 0) {
      tips =
        "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
        props.tips +
        "<br/><br/>";
    }
    await confirmBox(
      `<span style='color:red'>${tips}</span>是否确定上传<br/>${rawFile.name} ${sizeStr}`,
    )
      .then((aaa) => {
        resolve(true);
      })
      .catch(() => {
        reject(false);
      });
  });
};
// 文件上传时
const handleUploadProgress = (evt, uploadFile, uploadFiles) => {
  LoadingInstance = ElLoading.service({
    lock: true,
    text: `正在导入 ${uploadFile.name}，请稍后`,
    background: "rgba(0, 0, 0, 0.7)",
  });
};
const downFiles = (data) => {
  let blob = new Blob([data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
  });
  let url = window.URL.createObjectURL(blob); // 创建一个临时 url 指向 blob 对象
  let a = document.createElement("a");
  a.href = url;
  a.download = new Date().getTime();
  a.click();
  // 释放这个临时的对象 url
  window.URL.revokeObjectURL(url);
};
// 文件上传
const emits = defineEmits(["onErrorList", "success"]);
const handleUploadSuccess = (response, uploadFile, uploadFiles) => {
  LoadingInstance && LoadingInstance.close();
  if (props.resDataType === "file") {
    emits("onErrorList", response);
    return;
  }
  if (props.actionAddr === "/nodeInfo/importNodeInfoExcel") {
    // 导入用户接口 成功后下载
    succesMsg(`${uploadFile.name} 导入成功`);
    emits("success", response);
    // window.open(response)
    downFiles(response);
    return;
  }
  if (response.status === 1) {
    if (
      response.data &&
      Object.keys(response.data).length > 0 &&
      response.data.success !== true
    ) {
      emits("onErrorList", response.data, response.status);
      return;
    }
    succesMsg(`${uploadFile.name} 导入成功`);
    emits("success", response);
  } else {
    if (!response.data || response.data.length === 0) {
      errorMsg(response.message);
    } else {
      // 到处错误数据
      if (props.resDataType === "file") {
        emits("onErrorList", response);
      } else {
        emits("onErrorList", response.data, response.status);
      }
    }
  }
  uploadRef.value.clearFiles();
};

// 文件上传失败
const handleUploadError = (error, uploadFile, uploadFiles) => {
  LoadingInstance && LoadingInstance.close();
  if (error?.status) {
    alertBox(`接口请求状态 ${error.status}`, "确定", "error");
  }
};
</script>

<style lang="scss" scoped>
.textBtn:hover {
  // text-decoration: underline;
  .iconShow {
    color: #fff;
  }
}
</style>
